import { render, staticRenderFns } from "./notFound.vue?vue&type=template&id=ced4d7c0&scoped=true&"
import script from "./notFound.vue?vue&type=script&lang=js&"
export * from "./notFound.vue?vue&type=script&lang=js&"
import style0 from "./notFound.vue?vue&type=style&index=0&id=ced4d7c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced4d7c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ced4d7c0')) {
      api.createRecord('ced4d7c0', component.options)
    } else {
      api.reload('ced4d7c0', component.options)
    }
    module.hot.accept("./notFound.vue?vue&type=template&id=ced4d7c0&scoped=true&", function () {
      api.rerender('ced4d7c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/notFound.vue"
export default component.exports